const currentUrl = window.location.href;
const SERVER_BASE_URL = currentUrl && currentUrl.includes('mkportals-dev') ?  'https://mkportals-dev.marmonkeystone.com/api' : 
                        currentUrl && currentUrl.includes('mkportals-qa') ?   'https://mkportals-qa.marmonkeystone.com/api' : 
                        currentUrl && currentUrl.includes('mkportals-uat') ?  'https://mkportals-uat.marmonkeystone.com/api' : 
                        currentUrl && currentUrl.includes('ec2-18-233-9-19.compute-1.amazonaws.com') ?  'https://ec2-18-233-9-19.compute-1.amazonaws.com/api' : 
                        currentUrl && currentUrl.includes('mkportals.marmonkeystone.com') ?'https://mkportals.marmonkeystone.com/api' :  
                        currentUrl && currentUrl.includes('local') ? 'http://localhost:8080/marmon-portal-services' : 'http://127.0.0.1:8080/marmon-portal-services';
 

export default SERVER_BASE_URL;
